import dentalStatesIdx from "@/configs/dental-states/index";
import protocols from "@/configs/protocols/protocols";

export const initSettings = (storedSettings) => {
    try {
        let storedSettings = localStorage.getItem("settings");
        if (storedSettings === null) {
            const isiOS = !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);

            window.flutterEventLog.unshift({
                eventName: "initSettings-null-stored",
                data: {},
            });

            window.Tracker.logEvent({
                event_name: "null-stored",
                event_category: "initSettings",
            });

            // No care!
            // if (!isiOS && !this.plan3settingsLoaded) {
            //     this.loadPlan3Settings();
            //     return;
            // } else {
                app.$router.push("/settings-wizard");
                return;
            // }
        }

        storedSettings = JSON.parse(storedSettings);

        if (typeof storedSettings !== "object" || typeof storedSettings.protocols !== "object") {
            window.flutterEventLog.unshift({
                eventName: "initSettings-not-obj",
                data: {},
            });
            window.Tracker.logEvent({
                event_name: "not-obj",
                event_category: "initSettings",
            });
            app.$router.push("/settings-wizard");
        } else {
            app.$store.state.localSettings = storedSettings;
            app.$store.state.dentalStates = storedSettings.dentalStates;

            app.$store.state.dentalNotation = storedSettings.dentalNotation;
            app.$store.state.language = storedSettings.language;
            app.$store.state.currency = storedSettings.currency;
            window.i18n.locale = app.$store.state.language;

            app.$store.state.localSettings = storedSettings;
            app.$store.state.dentalStates = storedSettings.dentalStates;

            updateProtocols(storedSettings.protocols);

            if (typeof app.$store.state.language === "undefined") app.$store.state.language = "en";
            if (typeof app.$store.state.currency === "undefined") app.$store.state.currency = "USD";

            updateSettings();

            // eslint-disable-next-line no-console

            // Fix 1005 id in state 1006
            app.$store.state.dentalStates["1006"].id = "1006";
        }
    } catch(error) {
        window.captureException(error);
        window.Tracker.logEvent({
            event_name: "error",
            event_category: "initSettings",
        });
        window.flutterEventLog.unshift({
            eventName: "initSettings-error-fallback",
            data: {},
        });
        app.$router.push("/settings-wizard");
    }
};

const updateSettings = () => {
    Object.keys(dentalStatesIdx).forEach((id) => {
        if (typeof app.$store.state.dentalStates[id] === "undefined") {
            app.$store.state.dentalStates[id] = dentalStatesIdx[id];
        }
    });
};

const updateProtocols = (stored) => {
    const localProtocols = JSON.parse(JSON.stringify(protocols));
    Object.keys(stored).forEach((key) => {
        if (typeof stored[key].variations === "undefined") {
            // return;
        }

        // protocols[key].variations = stored[key].variations;
        localProtocols[key].active = stored[key].active;
        localProtocols[key].variation_active = stored[key].variation_active;
        localProtocols[key].variation_titles = stored[key].variation_titles;
        localProtocols[key].variation_prices = stored[key].variation_prices;
        localProtocols[key].opened = typeof stored[key].opened !== "undefined" ? stored[key].opened : 1;
    });
    app.$store.state.localSettings.protocols = localProtocols;
};
